import { render, staticRenderFns } from "./JoaEmployeeLeaveList.vue?vue&type=template&id=630b6fe0&scoped=true&"
import script from "./JoaEmployeeLeaveList.vue?vue&type=script&lang=js&"
export * from "./JoaEmployeeLeaveList.vue?vue&type=script&lang=js&"
import style0 from "./JoaEmployeeLeaveList.vue?vue&type=style&index=0&id=630b6fe0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b6fe0",
  null
  
)

export default component.exports